import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/Buttons';
import EmptyState from '../../../components/EmptyState';

import { P } from '../../../components/Typography';
import { Allow } from '../../../auth/accessToken';

import { TFunction } from 'i18next';
import { CustomerOrGap } from '../types';
import NoCustomers from './NoCustomers';
import { safeDecodeURIComponent } from '../../../helpers/formatters';

export interface ListMessageProps extends WithTranslation {
    queryParams: URLSearchParams;
    customers: CustomerOrGap[];
    isLoading: boolean;
    isLoadingNext: boolean;
    accountId: string;
    hasNext: boolean;
}

// TODO: Format since_datetime
const getEmptyFilterStringPart = (t: TFunction, locationQueryParams: URLSearchParams) =>
    [...locationQueryParams.entries()].map(([_, value]) => safeDecodeURIComponent(value)).join(', ');

const ListMessage = (
    {
        t,
        customers,
        isLoading,
        accountId,
        queryParams,
        isLoadingNext,
    }: ListMessageProps
) => {
    if (isLoading || isLoadingNext) {
        return null;
    }
    const locationValues = getEmptyFilterStringPart(t, queryParams);
    // The account has no customers yet
    if (!isLoading && customers.length === 0 && !locationValues) {
        return (
            <Allow
                anyOfScopes={[['admin'], ['admin:accounts'], ['write:accounts', 'read:accounts'], ['accounts:admin']]}
                fallback={
                    <EmptyState>
                        <P>{t('customers.customers.empty_no_customers.message')}</P>
                    </EmptyState>
                }
            >
                <NoCustomers />
            </Allow>
        );
    }

    if (customers.length === 0 && locationValues) {
        return (
            <EmptyState>
                <P>
                    <Trans i18nKey="customers.customers.empty_filtered_list.message" values={{ locationValues }}>
                        Sorry, we can't find any customers matching <strong>{locationValues}</strong>.
                    </Trans>
                </P>
                <ButtonLink to={`/${accountId}/customers`}>
                    {t('customers.customers.empty_filtered_list.clear_search_and_filters')}
                </ButtonLink>
            </EmptyState>
        );
    }

    return null;
};

export default withTranslation()(ListMessage);
